import { Vue, Component, Prop, Emit, Watch, Ref } from 'vue-property-decorator'
import './index.less'

import {
  OrderProcessMaterialServiceProxy,
  ProductionPlan,
  OrderProcessMaterialVO,
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import MaterialEdit from './Edit'
const orderProcessMaterialServiceProxy = new OrderProcessMaterialServiceProxy()
@Component
export default class WorkMaterialList extends Vue {
  // 物料需求清单
  @Prop({ default: null }) readonly plan: ProductionPlan

  planId = ''
  loading = false
  tableData: OrderProcessMaterialVO[] = []
  // columns = []
  selectedRowIndex = ''
  selectedRow = {} 
  visible = false
  isAssign = false
  selectId = ''
  get selectedKeys() {
    return [this.selectedRowIndex]
  }
  get columns() {
    let column={
      materialCode: 'page_product_materialCode',
      materialName: 'page_business_material_name',
      standardModel: 'page_material_check_standardModel',
      unit: 'page_material_check_unit',
      orderCode: 'page_plan_order_no',
      processName: 'page_plan_craft_name',
      requireNum: 'page_plan_demand_quantity',
      assignedNum: 'page_plan_assigned_quantity',
      numNotAssigned: 'page_material_demand_undelivered_quantity',
      receiveNum:'page_plan_quantity_received',
    }
    let temp = []
    for(let key in column){
      temp.push({
        title: this.$t(column[key]),
        key: key,
        dataIndex: key,
        width: 100,
        ellipsis: true
      })
    }
    return temp
  }
  @Emit("cancel")
  onCancel(flag) {
    this.visible = false
    if (flag) {
      this.getTableData()
    }
  }


  @Watch('plan', { immediate: true, deep: true })
  handlePlanChange(val) {
    console.log('plan:', val)
    this.planId = val ? val.id : ''
    if (this.planId) {
      this.getTableData()
    }
  }

  async getTableData() {
    
    try {
      this.loading = true
      let orderList = await orderProcessMaterialServiceProxy.orderProcessMaterialDetail(this.planId)
      this.tableData = orderList
      
      if (this.tableData.length > 0) {
        this.selectedRow = this.tableData[0]
        this.selectedRowIndex = this.tableData[0].id
      }
    } catch (e) {

    }
    this.loading = false

  }
  select(ids) {
    this.selectId=ids[0]
    this.selectedRowIndex=ids[0]
    this.selectedRow = this.tableData.filter(res => res.id === ids[0]) && this.tableData.filter(res=> res.id === ids[0])[0]
  }
  edit(flag) {
    this.visible = true
    this.isAssign = flag
  }

  clickRow(record, index) {
    console.log('111', record, index)
    this.selectedRowIndex = record.id
    this.selectedRow = record
    this.selectId = record.id
    
  }
  
  render() {
    return (
      <div class="requirement">
        <div class="table-panel">
          <div class="panel1">
            <div style="padding: 8px;">
              <a-button onClick={() => this.edit(true)} disabled={Object.keys(this.selectedRow).length === 0}>编辑派料情况</a-button>
              <a-button onClick={() => this.edit(false)} disabled={Object.keys(this.selectedRow).length === 0}>编辑退料情况</a-button>
            </div>
              <ml-table
                loading={this.loading}
                columns={this.columns}
                dataSource={this.tableData}
                size="small"
                rowKey="id"
                canChangeColWidth={true}
                pagination={false}
                selectRowKey={this.selectId}
                customRow={(record, index) => ({
                  on: {
                    click: () => {
                      this.clickRow(record, index)
                    },
                  },
                })}
                rowSelection={{ type: 'radio', onChange: this.select,  selectedRowKeys: this.selectedKeys }}
              >
            </ml-table>
          </div>
        </div>
        <MaterialEdit onCancel={this.onCancel} visible={this.visible} orderProcess={this.selectedRow} isAssign={this.isAssign}></MaterialEdit>
      </div>
    )
  }
}
